import { CartAddEvent } from '@theme/events';

// Fixed seven-stem forms use the native variants and cart drawer. Native POST
// remains the fallback; no builder minimum or synthetic product price applies.
class RdbStemCart extends HTMLElement {
  #abort;
  connectedCallback() {
    this.#abort?.abort();
    this.#abort = new AbortController();
    this.addEventListener('submit', this.#submit, { signal: this.#abort.signal });
  }
  disconnectedCallback() { this.#abort?.abort(); }
  #submit = async (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    const button = form.querySelector('[type="submit"]');
    if (!button) return;
    event.preventDefault();
    if (button.disabled || form.getAttribute('aria-busy') === 'true') return;
    const status = form.querySelector('[data-stem-status]');
    const message = form.querySelector('[data-stem-message]');
    const cartLink = form.querySelector('[data-stem-cart-link]');
    const signal = this.#abort.signal;
    const body = new FormData(form);
    // Quantity is fixed in HTML and pinned here against unrelated UI changes.
    body.set('quantity', '7');
    const sections = [...document.querySelectorAll('cart-items-component[data-section-id]')].map(e => e.dataset.sectionId);
    body.set('sections', [...new Set(sections)].join(','));
    body.set('sections_url', location.pathname);
    button.disabled = true;
    form.setAttribute('aria-busy', 'true');
    status.hidden = false;
    status.removeAttribute('data-error');
    cartLink.hidden = true;
    message.textContent = this.dataset.loading;
    let accepted = false;
    let rejected = false;
    try {
      const response = await fetch(this.dataset.cartAddUrl || form.action, {
        method: 'POST', body, signal, headers: { Accept: 'application/json' }
      });
      const result = await response.json();
      if (!response.ok || result.status) {
        rejected = response.status >= 400 && response.status < 500;
        throw new Error(result.description || result.message || this.dataset.error);
      }
      // Commit the known outcome before presentation or navigation can fail.
      accepted = true;
      message.textContent = this.dataset.success;
      cartLink.hidden = false;
      this.dispatchEvent(new CartAddEvent({}, body.get('id'), {
        // The native header treats this source as an increment, not a new total.
        source: 'product-form-component', itemCount: 7, productId: this.dataset.productId, sections: result.sections
      }));
      if (document.documentElement.hasAttribute('data-rdb-delivery')) {
        window.location.assign(this.dataset.cartUrl || cartLink.href);
      } else {
        button.disabled = false;
      }
    } catch (error) {
      if (signal.aborted) return;
      if (accepted) {
        // A failed redirect or drawer refresh must never invite another POST.
        message.textContent = this.dataset.success;
        cartLink.hidden = false;
      } else if (rejected) {
        status.setAttribute('data-error', '');
        message.textContent = error.message || this.dataset.error;
        button.disabled = false;
      } else {
        // A lost/unreadable response does not prove the server rejected the add.
        status.setAttribute('data-error', '');
        message.textContent = this.dataset.review;
        cartLink.hidden = false;
      }
    } finally {
      form.removeAttribute('aria-busy');
    }
  };
}
if (!customElements.get('rdb-stem-cart')) customElements.define('rdb-stem-cart', RdbStemCart);
